import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Category from '../components/Category';
import BackArrow from '../components/BackArrow';

import '../css/projects.css';

import modeling1 from '../img/modeling/jamie-sparker-modeling.jpg';

function Modeling() {
  return (
    <Container id='projects'>
      <BackArrow lastPage='/projects' />
      <Row className='projects-row'>
        <Category
          photo={modeling1}
          title={`Headshots`}
          overlay={'0.4'}
          route='headshots'
          routable={true}
          hover={true}
        />
      </Row>
    </Container>
  );
}

export default Modeling;
